if (document.getElementById('page-bbs')) {
  bbsPage()
}
function bbsPage() {
  //  ##      ##  ##  ##  #####
  //  ##      ##  ## ##   ##
  //  ##      ##  ####    #####
  //  ##      ##  ## ##   ##
  //  ######  ##  ##  ##  #####
  // 高評価、低評価のカウント
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-bbsLike')) {
      return
    }

    const item = e.target
    const id = e.target.dataset.id
    const type = item.dataset.type
    const reverse = item.dataset.reverse
    const count = document.querySelector('.js-bbsLike-count--' + id + '-' + type)

    if (item.classList.contains('active')) {
      // 加算の取り消し
      item.classList.remove('active')
      count.innerText = parseInt(count.innerText, 10) - 1
      return
    }
    if (!item.classList.contains('active')) {
      // 加算
      item.classList.add('active')
      count.innerText = parseInt(count.innerText, 10) + 1

      // 反対の評価の加算取り消し
      const reverseItem = document.querySelector('.js-bbsLike--' + id + '-' + reverse)

      if (reverseItem.classList.contains('active')) {
        // 加算の取り消し
        const reverseCount = document.querySelector('.js-bbsLike-count--' + id + '-' + reverse)
        reverseItem.classList.remove('active')
        reverseCount.innerText = parseInt(reverseCount.innerText, 10) - 1
      }

      return
    }
  })
}
